import React from 'react';

function About() {
  return (
    <div className="bg-gradient-primary min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            
            {/* 헤더 */}
            <div className="text-center py-5">
              <h1 className="h1 text-white mb-4">
                <i className="fas fa-user-circle me-3"></i>
                서비스 소개
              </h1>
              <p className="lead text-white-50 mb-0">
                노후 준비 연금 계산기를 만든 이유와 목적
              </p>
            </div>

            {/* 서비스 소개 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  <i className="fas fa-info-circle me-2"></i>
                  노후 준비 연금 계산기란?
                </h3>
              </div>
              <div className="card-body">
                <p className="text-gray-700 mb-4">
                  노후 준비 연금 계산기는 <strong>두 가지 방식으로 노후 자금을 계획</strong>할 수 있는 전문 웹 서비스입니다.
                  복리 계산과 현금흐름 시뮬레이션을 통해 실질적인 노후 준비 계획을 세울 수 있도록 도와드립니다.
                </p>
                
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="card bg-light h-100">
                      <div className="card-body">
                        <h5 className="text-primary">
                          <i className="fas fa-calculator me-2"></i>
                          일반 계산기
                        </h5>
                        <p className="mb-0">매월 저축 가능한 금액에서 출발하여 노후에 사용할 수 있는 생활비를 계산합니다.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card bg-light h-100">
                      <div className="card-body">
                        <h5 className="text-success">
                          <i className="fas fa-bullseye me-2"></i>
                          역산 계산기
                        </h5>
                        <p className="mb-0">원하는 노후 생활비에서 출발하여 현재부터 필요한 월 저축액을 계산합니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 서비스 특징 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  <i className="fas fa-star me-2"></i>
                  서비스 특징
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4 mb-4">
                    <div className="text-center">
                      <div className="text-primary mb-3" style={{fontSize: '3rem'}}>
                        <i className="fas fa-chart-line"></i>
                      </div>
                      <h5 className="font-weight-bold">정확한 복리 계산</h5>
                      <p className="text-gray-600">복리 수익률과 배당 수익률을 분리하여 더욱 정확한 시뮬레이션을 제공합니다.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <div className="text-center">
                      <div className="text-success mb-3" style={{fontSize: '3rem'}}>
                        <i className="fas fa-chart-pie"></i>
                      </div>
                      <h5 className="font-weight-bold">시각적 데이터</h5>
                      <p className="text-gray-600">Chart.js 그래프와 DataTables로 계산 결과를 직관적으로 확인할 수 있습니다.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <div className="text-center">
                      <div className="text-warning mb-3" style={{fontSize: '3rem'}}>
                        <i className="fas fa-mobile-alt"></i>
                      </div>
                      <h5 className="font-weight-bold">반응형 디자인</h5>
                      <p className="text-gray-600">PC, 태블릿, 모바일 모든 기기에서 최적화된 경험을 제공합니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 계산 방식 설명 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  <i className="fas fa-cogs me-2"></i>
                  계산 방식 및 가정
                </h3>
              </div>
              <div className="card-body">
                <div className="alert alert-info">
                  <h5 className="alert-heading">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    중요한 안내사항
                  </h5>
                  <p className="mb-0">
                    이 계산기는 <strong>교육 및 참고 목적</strong>으로만 사용하시기 바랍니다. 
                    실제 투자 결정 시에는 반드시 금융 전문가와 상담하시기 바랍니다.
                  </p>
                </div>
                
                <h5 className="mt-4 mb-3">📊 계산 공식</h5>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <i className="fas fa-arrow-right text-primary me-2"></i>
                    <strong>복리 계산:</strong> FV = PMT × [((1 + r)^n - 1) / r]
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-arrow-right text-primary me-2"></i>
                    <strong>현금흐름:</strong> 최종 적립액 × 연배당률 ÷ 12개월
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-arrow-right text-primary me-2"></i>
                    <strong>시뮬레이션:</strong> 5년 단위로 적립 과정을 시각화
                  </li>
                </ul>

                <h5 className="mt-4 mb-3">⚠️ 주요 가정사항</h5>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <i className="fas fa-check text-success me-2"></i>
                    수익률은 매년 일정하다고 가정 (실제로는 변동)
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check text-success me-2"></i>
                    인플레이션은 고려하지 않음
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check text-success me-2"></i>
                    세금 및 수수료는 별도 계산 필요
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check text-success me-2"></i>
                    매월 일정한 금액을 저축한다고 가정
                  </li>
                </ul>
              </div>
            </div>

            {/* 연락처 정보 */}
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary">
                  <i className="fas fa-envelope me-2"></i>
                  문의 및 개선 제안
                </h3>
              </div>
              <div className="card-body text-center">
                <p className="text-gray-600 mb-4">
                  서비스 개선 사항이나 문의사항이 있으시면 언제든지 연락해 주세요.
                </p>
                <div className="row justify-content-center">
                  <div className="col-md-8">
                    <div className="card bg-light">
                      <div className="card-body">
                        <h5 className="text-primary mb-3">
                          <i className="fas fa-code me-2"></i>
                          개발 정보
                        </h5>
                        <p className="mb-2">
                          <strong>개발도구:</strong> React.js + FastAPI + Firebase
                        </p>
                        <p className="mb-2">
                          <strong>데이터 처리:</strong> Python 수학 라이브러리
                        </p>
                        <p className="mb-0">
                          <strong>차트 라이브러리:</strong> Chart.js + DataTables
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default About;